import { render, staticRenderFns } from "./updateSettingDialog.vue?vue&type=template&id=5421cc7d&scoped=true&"
import script from "./updateSettingDialog.js?vue&type=script&lang=js&"
export * from "./updateSettingDialog.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5421cc7d",
  null
  
)

export default component.exports